<header>
    <div class="header" style="display:block">Logs</div>
    <button class="close" style="top:-3px" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</header>
<div class="body">
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <ag-grid-angular [enableCellTextSelection]="true" style="width:100%;height:340px;" id="LIOS-GRID-SMALL" class="ag-theme-balham"
        (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true" [getRowHeight]="getRowHeight"
        [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="rowData"  
        [context]="context" [icons]="icons">
    </ag-grid-angular>
</div>